module.exports = __webpack_public_path__ + "img/20190530161022QQ截图20190527164935.f7e21e0a.png";